// SHARED

// Foundations
import { Injectable } from '@angular/core';

// Models
import { Credentials } from '../models/credentials.model';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private _registerFormData: Credentials;
  public existingEmail: string;

  constructor() { }

  readRegisterFormData() {
    return this._registerFormData;
  }

  updateRegisterFormData(newData) {
    this._registerFormData = {
      ...this._registerFormData,
      ...newData
    };
  }
}
